import Model from './report.model'

let storeContent = utils.generateStore({
   Model,
   reports: [],
   selected_reports: [],
   show_send_report: false
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addReport(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_
            let recipients = data.recipients.map((recipient) => {
               return recipient.email
            })

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'insert',
                  data: {
                     record: {
                        subject: data.subject,
                        dashboard_id: data.dashboard_id,
                        days: data.days,
                        is_recurrent: data.is_recurrent,
                        recipients: recipients,
                     }
                  },
                  meta_data: {
                     service: "report",
                     collection: "report",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchReport')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Report Created', `Report ${data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateReport(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_
            let recipients = data.recipients.map((recipient) => {
               return recipient.email
            })

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_reports[0]._id,
                     record: {
                        subject: data.subject,
                        dashboard_id: data.dashboard_id,
                        days: data.days,
                        is_recurrent: data.is_recurrent,
                        recipients: recipients,
                     }
                  },
                  meta_data: {
                     service: "report",
                     collection: "report",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchReport')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Report Updated', `Report ${data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async sendReport(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_
            let recipients = data.recipients.map((recipient) => {
               return recipient.email
            })

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'report',
                  action: 'report:send',
                  data: {
                     report_id: ctx.getters.selected_reports[0]._id,
                     from: moment(`${data.period[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS'),
                     to: moment(`${data.period[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS'),
                     recipients,
                  },
                  meta_data: {}
               })

               await payload.ref.resetForms()
               ctx.commit('show_send_report', false)
               $notify('success', 'Request Submitted', `Report mail request has been sent.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteReport(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const report of ctx.getters.selected_reports) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: report._id,
                  },
                  meta_data: {
                     service: "report",
                     collection: "report",
                  }
               })
            }

            await ctx.dispatch('fetchReport')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Report Deleted', `<b>${ctx.getters.selected_reports.length}</b> Report successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'report:edit') {
            let Model = ctx.getters.Model
            Model.forms.editReport.data = payload.rows[0]

            Model.forms.editReport.data.recipients = payload.rows[0].recipients.map((recipient) => {
               return {id: Math.round(Math.random() * 100000),email: recipient}
            })
            ctx.commit('Model', Model)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_reports', payload.rows)
         } else if (payload.action === 'report:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Report`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_reports', payload.rows)
         } else if (payload.action === 'report:view') {
            // $session.set('selected_reports',payload.rows[0])
         }else if (payload.action === 'report:send') {
            let Model = ctx.getters.Model
            Model.forms.sendReport.data = payload.rows[0]

            Model.forms.sendReport.data.recipients = payload.rows[0].recipients.map((recipient) => {
               return {id: Math.round(Math.random() * 100000),email: recipient}
            })
            ctx.commit('Model', Model)
            ctx.commit('show_send_report', true)
            ctx.commit('selected_reports', payload.rows)
         }
      },
      async fetchReport(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "report",
                  collection: "report",
               }
            })
            ctx.commit('reports', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {},
               meta_data: {service: "analytics",collection: "dashboard"}
            })


            let new_model = utils.appendSelectData({
               Model: ctx.getters.Model,
               forms: ['addReport','editReport'],
               model: 'dashboard_id',
               label: 'name',
               dataField: '_id',
               data: await res.result.records.sort((a,b) => {return b.last_update - a.last_update})
            })

            
            ctx.commit('Model', new_model)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchReport')
            await ctx.dispatch('fetchFormData')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};